// src/constants.ts
var EVENT_LOCATIONS = {
  REGISTER_START: "Register Start",
  REGISTER_EMAIL_VERIFICATION: "Register Email Verification",
  REGISTER_PHONE: "Register Phone",
  REGISTER_PHONE_VERIFICATION: "Register Phone Verification",
  REGISTER_ADDRESS: "Register Address",
  REGISTER_VERIFY_ACCOUNT: "Register Verify Account",
  REGISTER_ACCOUNT_VERIFIED: "Register Account Verified",
  REGISTER_QUIT_CONFIRMATION: "Register Quit Confirmation",
  ADD_BANK_ACCOUNT_START: "Add Bank Account Start",
  ADD_BANK_ACCOUNT_DETAILS: "Add Bank Account Details",
  DEPOSIT: "Deposit",
  WITHDRAWAL: "Withdrawal",
  PIX: "Pix",
  LOCATION_PERMISSION: "Location Permission",
  ADD_BANK_VERIFY_ACCOUNT: "Add Bank Verify Account",
  HEADER: "Header",
  BURGER_MENU: "Burger Menu",
  USER_DROPDOWN_MENU: "User Dropdown Menu",
  HOW_TO_START_SECTION: "How to Start Section",
  CPF_BANNER: "CPF Banner",
  LOBBY_BANNER: "Lobby Banner",
  USP_BANNER: "UPS Banner",
  LOGIN_SCREEN: "Login Screen",
  BETSLIP: "Betslip",
  GAME_THUMBNAIL: "Game Thumbnail",
  PIX_PING_START: "Ping Pix Start",
  PIX_PING_CONFIRMATION: "Ping Pix Confirmation",
  LIVENESS_START: "Liveness Start",
  REGISTRATION_COMPLETED: "Registration Completed",
  INGAME_NAVBAR: "ingame_navbar",
  MY_ACCOUNT: "My Account"
};
var EVENT_NAMES = {
  SCREEN_LOADED: "Screen Loaded",
  PERSONAL_DATA_COMPLETED: "Personal Data Completed",
  CEP_ADDRESS: "CEP Address Completed",
  TERMS_AND_CONDITIONS_COMPLETED: "Terms and Conditions Completed",
  PARTIALLY_REGISTERED_USER: "Partially Registered User",
  FULLY_REGISTERED_USER: "Fully Registered User",
  EMAIL_INVALID_CODE_RETURNED: "Email Invalid Code Returned",
  PHONE_INVALID_CODE_RETURNED: "Phone Invalid Code Returned",
  LOCATION_SHARING_ENABLED: "Location Sharing Enabled",
  LOCATION_SHARING_DISABLED: "Location Sharing Disabled",
  ONBOARDING_TOUR: "onboarding_tour",
  CLUBE_KTO_ENTRY_POINT_LANDED: "clube_kto_entry_point_landed",
  CLUBE_KTO_MODAL_LOADED: "clube_kto_modal_loaded",
  CLUBE_KTO_WELCOME_PAGE_SCREEN_1_LOADED: "clube_kto_welcome_page_screen_1_loaded",
  CLUBE_KTO_WELCOME_PAGE_SCREEN_1_CTA_CLICKED: "clube_kto_welcome_page_screen_1_cta_clicked",
  CLUBE_KTO_WELCOME_PAGE_SCREEN_2_LOADED: "clube_kto_welcome_page_screen_2_loaded",
  CLUBE_KTO_WELCOME_PAGE_SCREEN_2_CTA_CLICKED: "clube_kto_welcome_page_screen_2_cta_clicked",
  CLUBE_KTO_ENTRY_POINT_DROP_DOWN_MENU: "clube_kto_entry_point_drop_down_menu",
  CLUBE_KTO_ENTRY_POINT_HEADER_MENU: "clube_kto_entry_point_header_menu",
  CLUBE_KTO_ENTRY_POINT_BURGER_MENU_WEBM: "clube_kto_entry_point_burger_menu_webm",
  CLUBE_KTO_ENTRY_POINT_BURGER_MENU_APP: "clube_kto_entry_point_burger_menu_app",
  LOG_IN: "Log In",
  LOG_OUT: "Log Out",
  KYC_START: "KYC Start",
  KYC_FAILED: "KYC Failed",
  DEPOSIT_COMPLETED: "deposit_completed",
  DEPOSIT_STARTED: "deposit_started",
  DEPOSIT_DISMISSED: "deposit_dismissed",
  REGISTER_METHOD_PAGE_VIEWED: "registrationw_method_page_viewed",
  REGISTER_WITH_EMAIL: "register_with_email",
  REGISTER_WITH_GOOGLE: "register_with_google",
  LOGIN_PAGE_VIEWED: "login_page_viewed",
  LOGIN_WITH_EMAIL: "login_with_email",
  LOGIN_WITH_GOOGLE: "login_with_google",
  SIGNUP_STARTED: "Sign-up Started",
  LOGIN_STARTED: "Login Started",
  GROWTHBOOK_EXPERIMENT: "growthbook_experiment",
  WITHDRAWAL_STARTED: "withdrawal_started",
  WITHDRAWAL_AMOUNT_LOADED: "withdrawal_amount_loaded",
  MANAGE_BANK_ACCOUNT_CLICKED: "manage_bank_account_clicked",
  WITHDRAWAL_BANK_ACCOUNT_CHOICE_LOADED: "withdrawal_bank_account_choice_loaded",
  WITHDRAWAL_REVIEW_LOADED: "withdrawal_bank_account_review_loaded",
  WITHDRAWAL_REQUESTED: "withdrawal_requested",
  WITHDRAWAL_REQUEST_SUCCESSFUL: "withdrawal_request_successful",
  INGAME_NAVBAR_TAPPED: "ingame_navbar_tapped",
  INGAME_DRAWER_OPENED: "ingame_drawer_opened",
  INGAME_ACTION_TAKEN: "ingame_action_taken",
  INGAME_DRAWER_DISMISSED: "ingame_drawer_dismissed",
  DEVICE_ORIENTATION_STATE: "device_orientation_state",
  LIGA_DO_MILHAO_POINTS_CALCULATOR_EXPANDED: "liga_do_milhao_expand_button",
  LIGA_DO_MILHAO_POINTS_CALCULATOR_COLLAPSED: "liga_do_milhao_collapse_button",
  LIGA_DO_MILHAO_POINTS_CALCULATOR_INITIATED: "liga_do_milhao_calculate_button",
  ACCOUNT_CLOSED: "account_closed",
  ACCOUNT_REOPENED: "account_reopened",
  SELF_EXCLUSION_REQUESTED: "self_exclusion_requested",
  PING_PIX_START_LOADED: "ping_pix_screen_loaded",
  PING_PIX_CONFIRMATION_LOADED: "ping_pix_confirmation_screen_loaded",
  LIVENESS_START_LOADED: "Liveness Start Loaded",
  DEPOSIT_AMOUNT_LOADED: "deposit_amount_screen_loaded",
  PIX_REVIEW_LOADED: "pix_review_screen_loaded",
  DEPOSIT_AMOUNT_EDITED: "deposit_amount_edited",
  LIVENESS_STARTED: "liveness_screen_loaded",
  LIVENESS_COMPLETED: "liveness_completed",
  RESET_PASSWORD_LOADED: "reset_password_screen_loaded",
  PASSWORD_RESET_SUCCESS: "password_reset_successful",
  EMAIL_OTP_INPUT_LOADED: "forgot_password_email_input_screen_loaded",
  PHONE_OTP_INPUT_LOADED: "forgot_password_sms_input_screen_loaded",
  EMAIL_OTP_VERIFICATION_LOADED: "mfa_email_otp_verification_screen_loaded",
  PHONE_OTP_VERIFICATION_LOADED: "mfa_sms_otp_verification_screen_loaded",
  LOGIN_2FA_VERIFICATION_STARTED: "mfa_verification_screen_loaded",
  CHANGE_2FA_VERIFICATION_METHOD_CLICKED: "change_mfa_verification_method_clicked",
  FORGOT_PASSWORD_2FA_VERIFICATION_STARTED: "forgot_password_verification_screen_loaded",
  FACE_VERIFICATION_SKIPPED: "face_verification_skipped",
  ACCOUNT_CLOSURE_REQUEST: "account_closure_requested",
  NAVIGATION_LINK_TAPPED: "navigation_link_tapped",
  CARD_TAPPED: "card_tapped",
  CARD_ACTION_TAKEN: "card_action_taken"
};

// src/event-tracking-provider.tsx
import { useFeatureValue } from "@growthbook/growthbook-react";
import { isBrowser, useOrientation } from "@repo/utils";
import mixpanel from "mixpanel-browser";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";

// src/utils/affise-script.ts
import { EnvConfig } from "@repo/env-config";
var affiseScript = (onLoad) => {
  const scriptId = "affise-websdk";
  const existing = typeof document !== "undefined" ? document.getElementById(scriptId) : null;
  if (existing) {
    if (typeof onLoad === "function") {
      if (typeof window !== "undefined" && window.ASDK) onLoad();
      else existing.addEventListener("load", () => onLoad(), { once: true });
    }
    return existing;
  }
  const script = document.createElement("script");
  script.src = `${EnvConfig.GATSBY_AFFISE_TRACKING_URL}/websdk.js`;
  script.async = true;
  script.defer = true;
  script.dataset.affise = "true";
  script.id = scriptId;
  if (typeof onLoad === "function") {
    script.addEventListener("load", () => onLoad(), { once: true });
  }
  document.head.appendChild(script);
  return script;
};
var affise_script_default = affiseScript;

// src/utils/mixpanel-utils.ts
var getUserProfileProperties = (user) => {
  const {
    wallet,
    user_status,
    accept_news,
    accept_sms,
    accept_gdpr,
    accept_gdpr_marketing,
    accept_pp,
    accept_tc,
    is_push_notifications_allowed,
    created_at,
    last_login,
    national_id_status,
    kyc_status,
    email_verification_status,
    mobile_verification_status,
    auto_withdrawal_enabled,
    year_of_birth
  } = user || {};
  return {
    accept_news,
    accept_sms,
    accept_gdpr,
    accept_gdpr_marketing,
    accept_pp,
    accept_tc,
    is_push_notifications_allowed,
    created_at,
    last_login,
    national_id_status,
    kyc_status,
    email_verification_status,
    mobile_verification_status,
    auto_withdrawal_enabled,
    year_of_birth,
    user_status,
    wallet: {
      amount: wallet?.amount,
      active: wallet?.active,
      blocked_amount: wallet?.blocked_amount,
      unplayed_balance: wallet?.unplayed_balance
    }
  };
};

// src/utils/push-data-layer.ts
import { storageService } from "@repo/storage";
var pushDataLayer = ({
  eventName = "",
  data = {}
}) => {
  const user = storageService.getUser();
  const { dataLayer } = window;
  dataLayer.push({
    event: eventName,
    user_id: user?.id || null,
    ...data
  });
};
var normalizeDataLayerText = (text) => text.toLowerCase().split(" ").join("_");

// src/event-tracking-provider.tsx
import { jsx } from "react/jsx-runtime";
var EventTrackingContext = createContext(
  null
);
var EventTrackingProvider = ({
  children
}) => {
  const [mixpanelLoaded, setMixpanelLoaded] = useState(false);
  const trackingContextRef = useRef({
    game_id: null,
    game_type: null
  });
  const eventTrackingEnabled = Boolean(
    useFeatureValue("fe_igp_event_tracking_enabled", false)
  );
  const isAffiseEnabled = Boolean(
    useFeatureValue("affise_tracking_enabled", false)
  );
  const orientation = useOrientation();
  const trackEventInternal = useCallback(
    (eventName, properties = {}, sendGAEvent = false) => {
      if (!eventTrackingEnabled) return;
      if (!mixpanelLoaded) return;
      if (!isBrowser() || !eventName) return;
      const extendedProperties = {
        ...properties,
        env: process.env.GATSBY_MIXPANEL_ENV
      };
      mixpanel.track(eventName, extendedProperties);
      if (sendGAEvent) {
        pushDataLayer({
          eventName,
          data: extendedProperties
        });
      }
    },
    [eventTrackingEnabled, mixpanelLoaded]
  );
  const trackOrientationEvent = useCallback(
    (orientation_source = "orientation_change") => {
      const properties = {
        ...trackingContextRef.current,
        orientation,
        pathname: isBrowser() ? window.location.pathname : void 0,
        orientation_source
      };
      trackEventInternal(EVENT_NAMES.DEVICE_ORIENTATION_STATE, properties, true);
    },
    [trackEventInternal, orientation]
  );
  useEffect(() => {
    if (!eventTrackingEnabled) return;
    try {
      mixpanel.track("test_initialization_check", { test: true });
      setMixpanelLoaded(true);
      return;
    } catch {
    }
    mixpanel.init(process.env.GATSBY_MIXPANEL_PROJECT_TOKEN, {
      debug: process.env.GATSBY_MIXPANEL_ENV === "dev",
      track_pageview: process.env.GATSBY_MIXPANEL_TRACK_PAGEVIEW === "true" ? "url-with-path" : false,
      persistence: "localStorage",
      loaded: () => {
        setMixpanelLoaded(true);
      }
    });
  }, [eventTrackingEnabled]);
  const isFirstTracking = useRef(true);
  useEffect(() => {
    const shouldTrack = eventTrackingEnabled && mixpanelLoaded && isBrowser();
    if (!shouldTrack) return;
    const orientation_source = isFirstTracking.current ? "session_start" : "orientation_change";
    isFirstTracking.current = false;
    trackOrientationEvent(orientation_source);
  }, [eventTrackingEnabled, mixpanelLoaded, orientation, trackOrientationEvent]);
  useEffect(() => {
    if (!isAffiseEnabled || !isBrowser()) return;
    try {
      affise_script_default(() => {
        window.ASDK.configure({
          use_google_transparency: true,
          client_id: process.env.GATSBY_AFFISE_CLIENT_ID,
          tracking_domain: process.env.GATSBY_AFFISE_TRACKING_URL
        });
      });
    } catch (error) {
      console.error("Failed to append Affise script:", error);
    }
  }, [isAffiseEnabled]);
  const updateCurrentGameId = useCallback((gameId) => {
    trackingContextRef.current.game_id = gameId;
  }, []);
  const updateCurrentGameType = useCallback((gameType) => {
    trackingContextRef.current.game_type = gameType;
  }, []);
  const getTrackingContext = useCallback(() => {
    return trackingContextRef.current;
  }, []);
  const value = useMemo(
    () => ({
      eventTrackingEnabled,
      mixpanelLoaded,
      updateCurrentGameId,
      updateCurrentGameType,
      trackEventInternal,
      getTrackingContext
    }),
    [
      eventTrackingEnabled,
      mixpanelLoaded,
      updateCurrentGameId,
      updateCurrentGameType,
      trackEventInternal,
      getTrackingContext
    ]
  );
  return /* @__PURE__ */ jsx(EventTrackingContext.Provider, { value, children });
};
var useEventTracking = () => {
  const context = useContext(EventTrackingContext);
  const {
    eventTrackingEnabled,
    mixpanelLoaded,
    updateCurrentGameId,
    updateCurrentGameType,
    trackEventInternal,
    getTrackingContext
  } = context || {};
  const trackEvent = useCallback(
    (eventName, properties = {}, sendGAEvent = false) => {
      trackEventInternal?.(eventName, properties, sendGAEvent);
    },
    [trackEventInternal]
  );
  const identifyUser = (user) => {
    if (!eventTrackingEnabled) return;
    if (!mixpanelLoaded) return;
    if (!user?.id) return;
    mixpanel.identify(user.id.toString());
    const userProfileProperties = getUserProfileProperties(user);
    mixpanel.people.set(userProfileProperties);
  };
  const deidentifyUser = () => {
    if (!eventTrackingEnabled) return;
    if (!mixpanelLoaded) return;
    mixpanel.reset();
  };
  const optUserIn = () => {
    if (!eventTrackingEnabled) return;
    if (!mixpanelLoaded) return;
    if (mixpanel.has_opted_in_tracking()) return;
    mixpanel.opt_in_tracking();
  };
  const optUserOut = () => {
    if (!eventTrackingEnabled) return;
    if (!mixpanelLoaded) return;
    if (mixpanel.has_opted_out_tracking()) return;
    mixpanel.opt_out_tracking();
  };
  return {
    trackEvent,
    identifyUser,
    deidentifyUser,
    optUserIn,
    optUserOut,
    updateCurrentGameId,
    updateCurrentGameType,
    getTrackingContext,
    EVENT_NAMES,
    EVENT_LOCATIONS,
    mixpanelLoaded
  };
};
export {
  EVENT_LOCATIONS,
  EVENT_NAMES,
  EventTrackingProvider,
  affiseScript,
  getUserProfileProperties,
  normalizeDataLayerText,
  pushDataLayer,
  useEventTracking
};
